export const KLIP_ADDRESS = 'https://a2a-api.klipwallet.com/v2/a2a/prepare';
export const KLIP_REQUEST_ADDRESS = 'https://a2a-api.klipwallet.com/v2/a2a/result?request_key=';
